/**
 * Reference announcement/megaphone icon for the Notification Bar.
 * Exact asset from:
 *   https://img.b100vg.com/bvg/h5/assets/images/icon-set/index-theme-icon/index-announcement-icon.svg
 * Used on bdvegas.online as CSS mask-image on `.announcement-row .item-icon`.
 */
import announcementIcon from './index-announcement-icon.svg';

export const NOTICE_ICON_SRC = {
  announcement: announcementIcon,
};
